// extracted by mini-css-extract-plugin
export default {"Box":"EditEvent_Box__lCYuf","EventBox":"EditEvent_EventBox__BN6yn","BoxInnerHeader":"EditEvent_BoxInnerHeader__2UeuL","BoxHeader":"EditEvent_BoxHeader__wrDbe"};